import React from 'react';

import { getFormattedPrice } from '@tools/utils/common.tsx';

interface CustomerCreditCTAProps {
  availableCredit: number;
  appliedCredit: number;
  suggestedAmount: number;
  currency?: string;
  onApply: (amount: number) => void;
  onClear: () => void;
  disabled?: boolean;
}

export const CustomerCreditCTA: React.FC<CustomerCreditCTAProps> = ({
  availableCredit,
  appliedCredit,
  suggestedAmount,
  currency,
  onApply,
  onClear,
  disabled = false,
}) => {
  const hasCredit = availableCredit > 0.01;
  const canApplySuggested = hasCredit && suggestedAmount > 0.01;

  if (!hasCredit) {
    return (
      <div className="pos-payments__credit" aria-live="polite">
        <strong>Saldo del cliente</strong>
        <p className="pos-payments__credit-empty">No hay saldo disponible.</p>
      </div>
    );
  }

  return (
    <div className="pos-payments__credit" aria-live="polite">
      <div className="pos-payments__credit-header">
        <strong>Saldo del cliente</strong>
        <span className="pos-payments__credit-amount">
          {getFormattedPrice(availableCredit, currency)} disponibles
        </span>
      </div>

      {appliedCredit > 0 ? (
        <p className="pos-payments__credit-applied">
          Se aplicarán {getFormattedPrice(appliedCredit, currency)} como saldo.
          <button
            type="button"
            className="pos-payments__link"
            onClick={() => onClear()}
            disabled={disabled}
          >
            Quitar saldo
          </button>
        </p>
      ) : (
        <button
          type="button"
          className="pos-payments__cta"
          onClick={() => onApply(Math.min(availableCredit, suggestedAmount))}
          disabled={!canApplySuggested || disabled}
        >
          Agregar saldo al pago
        </button>
      )}
    </div>
  );
};

export default CustomerCreditCTA;
